/**
 * Art options for the two m2 scenes, so each candidate can be seen in place before one is
 * chosen: ?hero=a|b|crop and ?hole=a|b|wide. Without a param both are the portrait scenes with Zeus
 * at the centre (Alberto: Zeus always in the centre); ?hero=wide and ?hole=wide bring back
 * the landscape ones.
 */

export interface Art {
  src: string;
  position: string;
}

const HERO: Record<string, Art> = {
  wide: { src: '/redesign2/scenes/camp.webp', position: 'center' },
  c: { src: '/redesign2/mobile/hero-c.webp', position: 'center' },
  a: { src: '/redesign2/mobile/hero-a.webp', position: 'center' },
  b: { src: '/redesign2/mobile/hero-b.webp', position: 'center' },
  crop: { src: '/redesign2/scenes/camp.webp', position: '62% center' },
};

const HOLE: Record<string, Art> = {
  wide: { src: '/redesign2/scenes/blackhole.webp', position: 'center' },
  a: { src: '/redesign2/mobile/hole-a.webp', position: 'center' },
  b: { src: '/redesign2/mobile/hole-b.webp', position: 'center' },
};

const DEFAULT = {
  hero: { src: '/redesign2/mobile/hero-c.webp', position: 'center' },
  hole: { src: '/redesign2/mobile/hole-a.webp', position: 'center' },
};

export function pickArt(search: string): { hero: Art; hole: Art } {
  const q = new URLSearchParams(search);
  return {
    hero: HERO[q.get('hero') || ''] || DEFAULT.hero,
    hole: HOLE[q.get('hole') || ''] || DEFAULT.hole,
  };
}
